import React from 'react';
import { Line } from 'react-chartjs-2';

const EnrollmentChart = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      {
        label: 'New Enrollments',
        data: [30, 45, 60, 80, 95],
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
        borderColor: 'rgba(54, 162, 235, 1)',
        fill: true,
      },
    ],
  };

  return <Line data={data} />;
};

export default EnrollmentChart;
